class BaseURL {
  ENV = "UAT";

  url_prod = "https://prod-api.vedi.love/v4";
  url_dev = "https://dev-api.vedi.love";
  url_uat = "https://uat-api.vedi.love";
  url =
    this.ENV === "PROD"
      ? this.url_prod
      : this.ENV === "DEV"
        ? this.url_dev
        : this.url_uat;

  PROD_STRIP_KEY =
    "pk_live_51OL07UEGG5xXlgXr9GrQGv7qY212gysHUfYKUIScNWc6b3Ro6eKQv9EfWA1Y3Kyo6gxyZASJSSS0tqTZ40Qzn83B00mQRwY2u9";
  // UAT_STRIP_KEY =
  //   "pk_test_51OL07UEGG5xXlgXrkQr0CASAMcG8FpMQxSW5yrhCMRA8oNSMEC1iZoM3JaRJsaFuji87bzvMlNNZhO6BAdx6buuU00FKQdoPR4";
  UAT_STRIP_KEY =
    "pk_test_51QhwOgRtUlqW556JEkIncT53ULyMF1pQitAsV0SvPTZaZMStB8OBIyAuuyoaGohGsqVZMblnR8pPCr5m38lD9u27005AmA692J";

  STRIPE_PUBLIC_KEY =
    this.ENV === "PROD" ? this.PROD_STRIP_KEY : this.UAT_STRIP_KEY;

  socket_url_prod = "wss://vedaz.astroepigenetics.com";
  socket_url_dev = "wss://dev-api.vedi.love/ws/vedaz-chat";
  socket_url_uat = "wss://dev.astroepigenetics.com";

  SOCKET_URL =
    this.ENV === "PROD"
      ? this.socket_url_prod
      : this.ENV === "DEV"
        ? this.socket_url_dev
        : this.socket_url_uat;
}

let baseUrl = new BaseURL();
export default baseUrl;
